export async function userQuery({ client }) {
  const { data } = await client.get(`user/`);
  return data;
}
